import React, { useState, useEffect } from 'react';
import Style from './Patient.module.scss';
import moment from "moment";
import { $getLanguage, $t } from "../../helpers/translator";
import api from "../../helpers/api";
import SkinTypeSelector from "../miscellaneous/SkinTypeSelector/SkinTypeSelector";
import Loader from "../miscellaneous/Loader/Loader";
import { FaPencilAlt } from "react-icons/fa";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import PatientCreateEdit from "../clinic/PatientCreateEdit/PatientCreateEdit";
import Modal from "../miscellaneous/Modal/Modal";

function PatientDetails({ id, userType }) {
    const [ patient, setPatient ] = useState(null);
    const [ showEditPatientModal, setEditPatientModalShow ] = useState(false);
    const [ modalKey, setModalKey ] = useState(0);
    const lang = $getLanguage();

    useEffect(() => {
        getPatient();
    }, [])

    const getPatient = async () => {
        if (!id) {
            return;
        }
        let res = await api.get(`/patient?id=${id}&mode=all`);
        if (res.status === 200 && res.data) {
            if (res.data.data.data.length === 1) {
                let patientData = res.data.data.data[ 0 ];
                patientData.gender_id = Number(patientData.gender);
                patientData.gender = Number(patientData.gender) === 1 ? $t('global.general.male') : Number(patientData.gender) === 2 ? $t('global.general.female') : $t('global.general.other');
                patientData.birth_date = moment(patientData.birth_date).locale(lang).format('ll');
                patientData.age = moment().diff(patientData.birth_date, 'years')
                patientData.created_at = moment(patientData.created_at).locale(lang).format('ll');
                setPatient(patientData)
            }
        }
    }

    const closeModal = () => {
        // console.log(patients)
        setEditPatientModalShow(false);
    }

    const onModalSuccess = () => {
        closeModal();
        getPatient();
    }

    const renderCreateEditPatientModal = () => {
        return (
            <Modal key={ modalKey } content={ <PatientCreateEdit mode={ 'edit' }
                userType={ userType }
                patientData={ {
                    ...patient,
                    gender: patient.gender_id
                } }
                onSuccess={ onModalSuccess.bind(this) }
            /> }
                onClose={ (e) => {
                    closeModal()
                } }
                visible={ showEditPatientModal } />
        );
    }


    return (<>
        { patient !== null && renderCreateEditPatientModal() }
        <div className="alma-box">
            <div className="alma-box-header d-flex">
                <div>
                    <h3>{ $t('global.patients.patientDetails') }</h3>
                </div>
                <div style={ {
                    marginLeft: 'auto',
                } }>
                    { patient !== null && <button className="link-button button-medium" onClick={ (e) => {
                        setEditPatientModalShow(true);
                        setModalKey(modalKey + 1)
                    } }>
                        <Tooltip content={ 'Update Patient' }>
                            <FaPencilAlt />
                        </Tooltip>
                    </button> }
                </div>
            </div>
            <div className='container'>
                <div className='box'>
                    { patient ?
                        <div>
                            <div className={ Style[ "patient-details-content" ] }>
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.patientId') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.patient_id }</div>
                                </div>
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.patientName') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ `${patient.first_name} ${patient.last_name}` }</div>
                                </div>
                                <div className={ Style[ "detail-container" ] }>
                                    <SkinTypeSelector skinType={ patient.skin_id } onValueChange={ null }
                                        disabled />
                                </div>
                                { userType === 3 && <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.clinics.clinicName') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.clinic_name }</div>
                                </div> }
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.gender') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.gender }</div>
                                </div>
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.age') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.age }</div>
                                </div>
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.birthday') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.birth_date }</div>
                                </div>
                                <div className={ Style[ "detail-container" ] }>
                                    <div
                                        className={ Style[ "detail-header" ] }>{ $t('global.patients.joinedAt') }</div>
                                    <div className={ Style[ "detail-value" ] }>{ patient.created_at }</div>
                                </div>
                            </div>
                        </div>
                        :
                        <Loader /> }
                </div>
            </div>
        </div>
    </>)
}

export default PatientDetails;
